export default __webpack_public_path__ + "static/GrotesqueNo9-Regular-a9de5214d1717e1c9b5212291dba25c1.woff";